<template>
	<div class="container">
		<div class="content">
			<section class="join">
				<h2 class="tit_page">회원가입</h2>
				<div class="join_done">
					<p class="guide_text">
						<span>{{ coAccountVO.userName }}</span>님의 회원가입이 성공적으로 완료되었습니다.<br>가입하신 이메일로 인증메일이 발송됩니다. <br><strong>이메일 인증</strong> 후 최종가입승인 됩니다.</p>
					<p class="guide_text"><br><strong>가입인증메일을 받지 못하셨다면</strong> <br>가입확인메일 재발송 버튼을 통해 다시 받으실 수 있습니다.</p>
					<br>
					<table class="tbl">
						<tr>
							<th>아이디</th>
							<td>{{ coAccountVO.coEmailId }}</td>
						</tr>
					</table>
				</div>
				<div class="join_button">
<!--					<button type="submit" class="btn btn-lg btn_join"><router-link to="/">메인으로</router-link></button>-->
					<button type="button" class="btn btn-lg btn_join" @click="doSendAuth">가입확인메일 재발송</button>
				</div>
			</section>
		</div>
	</div>
</template>

<script>

export default {
	name: "joinDone",
	data() {

		return {
			caidx: this.$route.query.caidx,
			coAccountVO: new this.CoAccountVO(),
		}
	},
	created() {

		//this.swalUtils.gritter( "", "메인으로 이동합니다.", "error" )

		if ( this.caidx > 0 ) {
			this.getCoAccount();
		} else {
			this.swalUtils.fire("비정상적인 접근", "메인으로 이동합니다.", "error", true, true)
				.then((result) => {
					console.log( result )
				});
		}
	},
	methods: {


		getCoAccount() {

			this.$eventBus.$emit("startProgress")
			console.log( this.$route.params.caidx )
			this.axiosCaller.get( this, this.APIs.CO_ACCOUNT + "/", {
				caidx: this.caidx
			}, (res) => {
				this.$eventBus.$emit("doneProgress")
				const result = res.data
				this.coAccountVO = result.coAccountVO;
				//this.doSendAuth();
			})

		},


		doSendAuth () {

			this.$eventBus.$emit("startProgress", 2)
			this.axiosCaller.post( this, this.APIs.CO_ACCOUNT + "/doSendAuth/" + this.caidx, {
				caidx: this.caidx
			}, (res) => {
				const result = res.data
				if ( result.status === "ok" ) {
					this.swalUtils.gritter("인증메일 발송", "인증메일이 발송되었습니다. <br>메일 링크를 클릭하여 가입을 완료해주세요.", "info")
				}
				this.$eventBus.$emit("doneProgress", 2)
			})
		},

	}
}
</script>

<style scoped>

</style>